import React, { useEffect, useState } from 'react'
import {
    DKLabel,
    showToast,
    TOAST_TYPE,
    DKButton,
    DKIcon,
    DKInput,
    INPUT_VIEW_DIRECTION,
    showLoader,
    removeLoader
} from "deskera-ui-library";
import { useSelector } from 'react-redux';
import Utility, { deepClone } from '../../utility/Utility';
import ComponentGroupsService from '../../services/ComponentGroupsService';
import { selectTenanatData } from '../../Redux/Slices/EmployeeListSlice';
import ic_add_white from "../../assets/icons/ic_add_white.png";
import ic_delete from "../../assets/icons/ic_delete.png";
import { INPUT_TYPE } from '../../constants/Constant';
import { isUSCompliance, removeFirstDecimalFromInput } from '../../managers/common/CommonUtil';
import PayrollService from '../../services/PayrollService';
import { useTranslation } from 'react-i18next';

const AddComponentGroupPopup = (props) => {
    const { t, i18n } = useTranslation();

    let initializeState = {
    }

    useEffect(() => {
        loadComponents();
        loadBenefits();
    }, [])

    const [fixedCompsDefaultValues, setFixedCompsDefaultValues] = useState({}); //- Fixed values
    const [variableCompsDefaultValues, setVariableCompsDefaultValues] = useState({}); //- var values

    const [errorField, setErrorField] = useState({})
    const [fixedColConfigs, setFixedColConfigs] = useState([])
    const [variableColConfigs, setVariableColConfigs] = useState([])
    const [componentGroup, setComponentGroup] = useState({
        ...initializeState,
        "name": "",
    })
    const tenantData = useSelector(selectTenanatData);
    const [fixedComponents, setFixedComponents] = useState([]);
    const [variableComponents, setVariableComponents] = useState([]);
    const [benefitMeta, setBenefitMeta] = useState([])
    const [benefitList, setBenefitList] = useState([]);

    // useEffect(() => {
    //     updatePropsValue();
    // }, [fixedColConfigs, variableColConfigs])
    useEffect(() => {
        if (props.data) {
            let data = Object.assign({},props.data.data)
            setComponentGroup(data)
        }

    }, [props.data])

    useEffect(() => {
        if(variableComponents.length > 0){
            constUpdatePropsValueForVariable();
        }

    }, [variableComponents])

    useEffect(() => {
        if(fixedComponents.length > 0){
            constUpdatePropsValueForFixed();
        }

    }, [fixedComponents])

    const constUpdatePropsValueForFixed = () => {
        if(props.data && props.data.data) {
            if(props.data.data.fixedComponents) {
                let columnConfig = deepClone(fixedColConfigs);
                props.data.data.fixedComponents.forEach(element => {
                    let details = {};
                    details['columnCode'] = "";
                    details['name'] = "";
                    details['id'] = element.componentId;
                    details["error"] = false
                    details['options'] = fixedComponents;
                    details['isFormula'] = fixedComponents.find(f=>f.id==element.componentId)?.isFormula//element['isFormula'] ? element['isFormula'] :false
                    columnConfig.push(details);
                    let component = {}
                    component['details'] = element
                    component['amount'] = element.amount
                    fixedCompsDefaultValues[element.componentId] = component
                });
                setFixedColConfigs(columnConfig);
            }
        }
    }

    const constUpdatePropsValueForVariable = () => {
        if(props.data && props.data.data) {
            if(props.data.data.variableComponents) {
                let columnConfig = deepClone(variableColConfigs);
                props.data.data.variableComponents.forEach(element => {
                    let details = {};
                    details['columnCode'] = "";
                    details['name'] = "";
                    details["error"] = false
                    details['id'] = element.componentId;
                    columnConfig.push(details);
                    let component = {}
                    component['details'] = getVarComponentDetails(element.componentId)
                    variableCompsDefaultValues[element.componentId] = component
                });
                setVariableColConfigs(columnConfig);
            }
        }
    }
    const getVarComponentDetails = (props) => {
        let details = variableComponents.filter((x) => x.id === props)
        if(details.length > 0 ) {
            return details[0]
        } 
        return {}
    }
    const loadComponents = () => {
        showLoader();
        ComponentGroupsService.loadComponents()
            .then((response) => {
                removeLoader();
                if (response) {
                    
                    setComponentData(response['components']);
                }
            }
            )
    }
    const loadBenefits=()=>{
        if(isUSCompliance()) {
            PayrollService.getTenantBenefitsData().then(
                response=>{
                    if(response) {
                        setBenefitMeta(response['benefits'])
                        setBenefitField(response['benefits'])
                    }
                },
                error=>{
                    console.log(error)
                }
            )
        }
    }
    const setBenefitField = (list) => {
        if (props && props.data && props.data.data && props.data.data.benefits) {
            let benefilt = props.data.data.benefits
            let benefitsList = [];
            benefilt.forEach(data => {
                let index = list.findIndex(li => data.benefitId == li.benefitId);
                if (index != -1) {                    
                    let obj = {
                        options: list,
                        value: list[index]
                    }
                    benefitsList.push(obj);
                }
            })
            setBenefitList(benefitsList)
        }
    }

    const setComponentData = (componentList) => {
        setFixedComponents(componentList.filter((x) => !x.isVariable && x.isActive && !x.defaultComponent && !x.isHidden))
        setVariableComponents(componentList.filter((x) => x.isVariable && x.isActive && !x.defaultComponent && !x.isHidden))
    }
    const addColumnConfigForFixedComponent = () => {
        let columnConfig = deepClone(fixedColConfigs);
        let details = {}
        details['columnCode'] = "";
        details['name'] = "";
        details['options'] = fixedComponents;
        columnConfig.push(details);
        setFixedColConfigs(columnConfig);
    }
    const onDeleteFixedComponent = (index, object) => {
        let columnConfig = deepClone(fixedColConfigs);
        columnConfig.splice(index, 1);
        delete fixedCompsDefaultValues[object.id];
        setFixedColConfigs(columnConfig);
    }
    const onDeleteBenefit = (index,obj) => {
        let columnConfig = deepClone(benefitList);
        columnConfig.splice(index, 1);
        setBenefitList(columnConfig);
    }
    const onDeleteVariableComponent = (index, object) => {
        let columnConfig = deepClone(variableColConfigs);
        columnConfig.splice(index, 1);
        delete variableCompsDefaultValues[object.id];
        setVariableColConfigs(columnConfig)
    }

    const addColumnConfigForVariableComponent = () => {
        let columnConfig = deepClone(variableColConfigs);
        let details = {}
        details['columnCode'] = "";
        details['options'] = variableComponents;
        columnConfig.push(details);
        setVariableColConfigs(columnConfig);
    }
    const onChange = (value, index, object, section, fieldName) => {
        if (value && value === " ") {
            value = value.trim();
        }
        switch (section) {
            case "fixed":
                let columnConfig = deepClone(fixedColConfigs);
                if (fieldName === "component") {
                    columnConfig[index]['id'] = value.id
                    if(!value.id || Utility.isEmpty(value.id)){
                        columnConfig[index]['error'] = true
                    } else {
                        updateSelectedColumn(value, index, columnConfig, object);
                    }
                } else {
                    value = removeFirstDecimalFromInput(value);
                    if(!object.id || Utility.isEmpty(object.id)){
                        columnConfig[index]['error'] = true
                    } else {
                        fixedCompsDefaultValues[object.id].amount = value;
                    }
                }
                columnConfig[index]['isFormula'] = value['isFormula'] ? value['isFormula'] :false
                setFixedColConfigs(columnConfig);
                break;
            case "variable":
                let columnConfigVariable = deepClone(variableColConfigs);
                columnConfigVariable[index]['id'] = value.id
                updateSelectedColumnForVariable(value, index, columnConfigVariable, object);
                setVariableColConfigs(columnConfigVariable)
                break;
        }
    }
    const updateSelectedColumn = (value, index, columnConfig, object) => {
        let component = {}
        component['details'] = value
        fixedCompsDefaultValues[value.id] = component
    }
    const updateSelectedColumnForVariable = (value, index, columnConfigVariable, object) => {
        let component = {}
        component['details'] = value
        variableCompsDefaultValues[value.id] = component
    }
   const getFixedcomponentsRemainingOptions = () => {
       let alreadyAdded = [];
    for (var key of Object.keys(fixedCompsDefaultValues)) {
        alreadyAdded.push(key)
    }
    // var filtered = fixedComponents.filter(function(el) { return !alreadyAdded. }); 

   }
    const getFixedComponentList = () => {
        return fixedColConfigs.map((obj, index) => {
            return <div className="pr-l p-v-s" style={{ alignItems: "baseline" }}>
                <div className="row row-responsive pr-l web-width-40 padding-empty-mobile">
                    <DKInput
                        title={t("COMPONENT")}
                        className=""
                        formatter={(obj) => {
                            return obj.name;
                        }}
                        value={
                            fixedCompsDefaultValues[obj.id]
                                ? fixedCompsDefaultValues[obj.id]['details']
                                : []
                        }
                        type={INPUT_TYPE.DROPDOWN}
                        showError={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={false}
                        required={true}
                        canValidate={obj.error}
                        dropdownConfig={{
                            className: "",
                            style: {},
                            allowSearch: false,
                            searchableKey: undefined,
                            data: dropFixedDownOption(),
                            renderer: (index, obj) => {
                                return (
                                    <DKLabel
                                        text={`${obj.name}`}
                                    />
                                );
                            },
                            onSelect: (idx, value) => {
                                
                                onChange(value, index, obj, "fixed", "component")
                            },
                        }}
                        onChange={value => {
                        }
                        }
                    />
                    {!obj.isFormula && <DKInput
                        autoFocus={index === 0 && props.autoFocus === true}
                        value={fixedCompsDefaultValues[obj.id]
                            ? fixedCompsDefaultValues[obj.id]['amount']
                            : 0}
                        className="pl-s"
                        type={"number"}
                        labelClassName=" text-align-left "
                        title="Amount"
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        onChange={(value) => {
                            onChange(value, index, obj, "fixed", "amount");
                        }
                        }
                        readOnly={false}
                    />}
                    <div
                        onClick={() => onDeleteFixedComponent(index, obj)}
                        style={{ position: "relative", left: "10px", top: "15px" }}
                    >
                        <DKIcon src={ic_delete} className="cursor-hand" />
                    </div>
                </div>
            </div>
        }
        )
    }

    const dropFixedDownOption = () => {
        let dropDownOption = []
        fixedComponents.forEach(variable => {
            let a = fixedColConfigs.filter(obj => (variable.id === obj.id))

            if(a.length === 0 ){
                dropDownOption.push(variable)
            }
        })

        return dropDownOption
    }

    const getVariableComponentList = () => {
        return variableColConfigs.map((obj, index) => {
            return <div className="pr-l p-v-s" style={{ alignItems: "baseline" }}>
                <div className="row row-responsive pr-l web-width-40 padding-empty-mobile">
                    <DKInput
                        title={t("COMPONENT")}
                        formatter={(obj) => {
                            return obj.name;
                        }}
                        value={variableCompsDefaultValues[obj.id]
                            ? variableCompsDefaultValues[obj.id]['details']
                            : []}
                        type={INPUT_TYPE.DROPDOWN}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        dropdownConfig={{
                            className: "",
                            style: {},
                            allowSearch: false,
                            searchableKey: undefined,
                            data: dropVariableDownOption(),
                            renderer: (index, obj) => {
                                return (
                                    <DKLabel
                                        text={`${obj.name}`}
                                    />
                                );
                            },
                            onSelect: (idx, value) => {
                                
                                onChange(value, index, obj, "variable", "component")
                            },
                        }}
                        onChange={value => {
                        }
                        }
                    />
                    {/* <DKInput
                        // value={}
                        className="pl-s"
                        title="Amount"
                        canValidate={errorField.fieldName}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        onChange={(value) => {
                            if (value === "") {
                                setErrorField({ ...errorField, fieldName: true })
                            }
                            // componentGroup.name = value
                        }
                        }
                    /> */}
                    <div
                        onClick={() => onDeleteVariableComponent(index, obj)}
                        style={{ position: "relative", left: "10px", top: "15px" }}
                    >
                        <DKIcon src={ic_delete} className="cursor-hand" />
                    </div>
                </div>
            </div>
        }
        )
    }


    const dropVariableDownOption = () => {
        let dropDownOption = []
        variableComponents.forEach(variable => {
            let a = variableColConfigs.filter(obj => (variable.id === obj.id))

            if(a.length === 0 ){
                dropDownOption.push(variable)
            }
        })

        return dropDownOption
    }

    const getVariableComponentsSection = () => {
        return (
            <div>
                <div className="">
                    <DKLabel text={t("VARIABLE_COMPONENTS")} className="fs-m fw-m align-self-center width-80" />
                    {getVariableComponentList()}
                </div>
                {variableColConfigs.length < variableComponents.length && <div className="row p-v-l">
                    <DKButton
                        title={t("ADD_COMPONENT")}
                        onClick={() => addColumnConfigForVariableComponent()}
                        className="bg-app text-white"
                        icon={ic_add_white}
                    ></DKButton>
                </div>}
                {variableColConfigs.length === 0 && variableComponents.length == 0 && <div className="p-v-m">{t("NO_VARIABLE_COMP_AVAILABLE")}</div>}
            </div>
        )
    }
    const getFixedComponentsSection = () => {
        return (
            <div>
                <div className="">
                    <DKLabel text={t("FIXED_COMPONENTS")} className="fs-m fw-m align-self-center width-80" />
                    {fixedColConfigs.length > 0 && getFixedComponentList()}
                </div>
                {fixedColConfigs.length < fixedComponents.length && <div className="row p-v-l">
                    <DKButton
                        title={t("ADD_COMPONENT")}
                        onClick={() => addColumnConfigForFixedComponent()}
                        className="bg-app text-white"
                        icon={ic_add_white}
                    ></DKButton>
                </div>}
                {fixedColConfigs.length === 0 && fixedComponents.length == 0 && <div className="p-v-m">{t("NO_FIXED_COMP_AVAILABLE")}</div>}
            </div>
        )
    }

    const createFixedComponentsArray = () => {
        let arr = [];
        for (var key of Object.keys(fixedCompsDefaultValues)) {
            let item = deepClone (fixedCompsDefaultValues[key])
            let cmp = item['details']
            cmp.amount = item.amount
            cmp['componentId'] = Utility.isEmpty(cmp.id) ? cmp.componentId : cmp.id
            arr.push(cmp)
        }
        return arr;
    }
    const createVariableCompsArray = () => {
        let arr = [];
        for (let item in variableCompsDefaultValues) {
            arr.push({
                componentId: item
            })
        }
        return arr;
    }
    //
    const saveComponentGroup = () => {
        let isValid = true;
        if (componentGroup.name.trim() === "") {
            setErrorField({ ...errorField, fieldName: true })
            return
        }
        let fixedCompsList = createFixedComponentsArray()
        let payload = {
            id: props.data ? props.data.id :"",
            name: componentGroup.name,
            hasFixedComponents: fixedCompsList.length > 0,
            fixedComponents: fixedCompsList,
            variableComponents: createVariableCompsArray(),
            hasVarComponents: createVariableCompsArray().length > 0,
            applyToAll: true,
            users: []
        };
        if(isUSCompliance()) {
            let benefitArr = getBenefitArray()
            if(!benefitArr) {
                isValid = false
                setBenefitList(deepClone(benefitList))
                return;
                
            }
            payload['benefits'] = benefitArr
        }
        if(!isValid) {
                return
        }
        showLoader();
        if(!props.data){
            ComponentGroupsService.AddComponentGroup(payload).then(response => {
                removeLoader();
                props.onClose(true);
                showToast(t("COMP_TEMP_ADD_SUCCESS"), TOAST_TYPE.SUCCESS)
            }, error => {
                removeLoader();
                console.log(error)
            })
        } else {
            ComponentGroupsService.UpdateComponentGroup(payload).then(response => {
                removeLoader();
                props.onClose(true);
                showToast(t("COMP_TEMP_UPDATE_SUCCESS"), TOAST_TYPE.SUCCESS)
            }, error => {
                removeLoader();
                console.log(error)
            })
        }
    }
    const getBenefitArray = () => {
        let response = []
        let isValid = true;
        benefitList.forEach(data=>{
            if(data.value&&data.value.benefitId) {
                response.push({
                    "benefitId":data.value.benefitId
                })
            } else {
                isValid = false
            }
            
        })
        return isValid ? response : isValid;
    }
    const getBenefitFields = () => {
        return ( 
            benefitList.map( (benefit,ind) => {
                return (
                    <div className="row justify-content-between">
                    <div className="parent-width pr-m">
                        <DKInput
                        title="Benefit"
                        className=""
                        formatter={(obj) => {
                            return obj.name;
                        }}
                        value={benefit.value}
                        type={INPUT_TYPE.DROPDOWN}
                        showError={true}
                        direction={INPUT_VIEW_DIRECTION.VERTICAL}
                        readOnly={false}
                        required={true}
                        
                        canValidate={true}
                        dropdownConfig={{
                            className: "",
                            style: {},
                            allowSearch: false,
                            searchableKey: undefined,
                            data: benfitDropDownOption(benefit.options),
                            renderer: (index, obj) => {
                                return (
                                    <DKLabel
                                        text={`${obj.name}`}
                                    />
                                );
                            },
                            onSelect: (index, value) => {
                                onBenefitSelect(ind,value)
                                
                            },
                        }}
                        onChange={value => {
                        }
                        }
                    />
                    </div>
                    <div className="mt-xl mr-xl"
                        onClick={() => onDeleteBenefit(ind, benefit)}
                        
                    >
                        <DKIcon src={ic_delete} className="cursor-hand" />
                    </div>
                    </div>
                )
                }
            )
        )
    }

    const benfitDropDownOption = (benefitOption) => {
        let dropDownOption = []

        benefitOption.forEach(option=>{
            let op = benefitList.filter(value => (value.value && value.value.benefitId === option.benefitId))
            if(op.length === 0){
                dropDownOption.push(option)
            }
        })


        return dropDownOption
    }

    const onBenefitSelect = (index,value) =>{
        let list = deepClone(benefitList)
        list[index].value = value;
        
        setBenefitList(list)

    }
    const addBenefitField = ()=>{
        let list = deepClone(benefitList)
        let obj = {
            options : benefitMeta,
            value:null

        }
        list.push(obj);
        setBenefitList(list)
    }
    const getBenefitSection = () => {
        return (
            <>
            <DKLabel 
            className="fs-m fw-m mt-l"
            text="Benefits"/>
            {benefitMeta.length != 0 && getBenefitFields()}
            {benefitMeta.length == 0 && <DKLabel text="No benefits found."/>}
            <div className="d-flex">
            {benefitList.length < benefitMeta.length && <DKButton
                        title="Add Benefits"
                        onClick={() => addBenefitField()}
                        className="bg-app text-white m-v-l"
                        icon={ic_add_white}
                    />}
            </div>
            </>
        )
    }
    return (
        <div className="popup-window" style={{ maxWidth: 600 }}>
            <div className="row">
                <DKLabel text={props.data ? t("EDIT_COMP_TEMP") : t("ADD_COMP_TEMP")}  className="fs-m fw-m align-self-center parent-width" />
                <div className="row-reverse ">
                    <DKButton
                        title="Save"
                        className="border-m ml-r bg-app text-white"
                        onClick={() => {
                            saveComponentGroup()
                        }}
                    />
                    <DKButton
                        title="Cancel"
                        className="g-gray1 border-m"
                        onClick={(event) => {
                            props.onClose();
                        }}
                    />
                </div>
            </div>
            <div className="parent-width custom-scroll scrollbar-thin" style={{ overflowY: "auto", overflowX: "hidden" }}>
                <div className="p-s">
                    <div className="column row mb-l" style={{ width: "47%" }}>
                        <DKInput
                            value={componentGroup.name}
                            title="Template Name"
                            canValidate={errorField.fieldName}
                            direction={INPUT_VIEW_DIRECTION.VERTICAL}
                            onChange={(value) => {
                                if (value === "") {
                                    setErrorField({ ...errorField, fieldName: true })
                                }
                                componentGroup.name = value
                            }
                            }
                        />
                    </div>
                    {getFixedComponentsSection()}
                    {getVariableComponentsSection()}
                    {isUSCompliance() && getBenefitSection()}
                </div>
            </div>
        </div>

    )

}

export default AddComponentGroupPopup